import * as globals from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

import WBReactTable from '../../WBReactTable';

export const TriggersTable = styled(WBReactTable)`
  margin: 16px;
`;
TriggersTable.displayName = 'S.TriggersTable';

export const LinkedName = styled.div`
  align-self: flex-start;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: ${globals.Colors.TEAL_DARK};
`;
LinkedName.displayName = 'S.LinkedName';

export const Name = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  align-self: flex-start;
`;
Name.displayName = 'S.Name';

export const Cell = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
`;
Cell.displayName = 'S.Cell';

export const NumberCircle = styled.div<{disabled?: boolean}>`
  width: 40px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  font-size: 24px;
  background: ${props => (props.disabled ? globals.gray400 : globals.primary)};
  color: white;
  margin-right: 12px;
`;
NumberCircle.displayName = 'S.NumberCircle';

export const TriggerStep = styled.div<{disabled?: boolean}>`
  border-left: 1px solid #ccc;
  margin: 12px 16px;
  opacity: ${props => (props.disabled ? 0.4 : 1)} . > div {
    opacity: ${props => (props.disabled ? 0.4 : 1)};
  }
`;

export const TriggerStepHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  margin-bottom: 6px;
  position: relative;
  right: 20px;
`;

export const TriggerStepAction = styled.div`
  margin: 12px 0px 12px 36px;
  width: 500px;
`;

export const InlineBlockAction = styled.div`
  display: inline-block;
  margin-top: 10px;
  margin-left: 36px;
`;
InlineBlockAction.displayName = 'S.InlineBlockAction';

export const TemplateStringHelperDiv = styled.div`
  margin-left: 18px;
  margin-bottom: 12px;
  background: white;
  border: 1px solid ${globals.gray300};
  max-width: 800px;
  min-width: 592px;
  border-radius: 3px;
`;

export const TemplateHelperRow = styled.div`
  marin-bottom: 12px;
  display: flex;
`;
export const TemplateStringName = styled.div`
  font-size: 18px;
`;

export const TemplateStringHelp = styled.div`
  font-size: 16px;
  color: ${globals.gray600};
  margin-bottom: 8px;
  margin-left: 2px;
`;

export const SpacerDiv = styled.div`
  margin-left: 12px;
`;

export const EditorDiv = styled.div`
  max-width: 800px;
  min-width: 592px;
  border-radius: 3px;
  margin-bottom: 12px;
  margin-left: 18px;
  .editor-wrapper {
    position: relative;
    min-height: 200px;
  }
`;

export const TriggerStepDescription = styled.div`
  margin-left: 36px;
  margin-top: 12px;
`;

export const PopupCellText = styled.div`
  display: inline;
`;

export const TriggerCreationHeader = styled.div`
  margin-left: 12px;
  font-size: 18px;
`;

export const TriggerCreationTitle = styled.div`
  margin-left: 12px;
  font-size: 24px;
  margin-bottom: 12px;
`;

export const DescriptionSelectorDiv = styled.div`
  margin-left: 18px;
  margin-bottom: 8px;
`;

export const ErrorHighlight = styled.div`
  color: ${globals.Colors.GRAY_500};
  font-style: italic;
  font-weight: 400;
`;
ErrorHighlight.displayName = 'S.ErrorHighlight';
